<template>
  <div class="select-dropdown-container" ref="dropdown">
    <div class="relative">
      <input
        :value="modelValue"
        @input="onInput"
        @focus="onFocus"
        :placeholder="placeholder"
        @blur="validateSelection"
        class="input"
        autocomplete="off"
        :required="required"
        ref="input"
        :maxlength="maxLength"
      />
      <div v-if="modelValue" class="clear-button" @click="clearSelection">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>
    </div>

    <div v-if="isOpen && modelValue && modelValue.length > 0" class="dropdown-list">
      <div
        v-for="option in filteredOptions"
        :key="option.value"
        @mousedown.prevent="selectOption(option)"
        class="dropdown-item"
      >
        <span>{{ option.label }}</span>
        <span class="option-value" v-if="showValue">&nbsp;({{ option.value }})</span>
      </div>
      <div v-if="filteredOptions.length === 0" class="dropdown-no-results">
        No results found
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StateDropdown',
  props: {
    modelValue: {
      default: null
    },
    options: {
      required: true,
      default: () => []
    },
    placeholder: {
      default: 'Select an option...'
    },
    required: {
      default: false
    },
    showValue: {
      default: false
    },
    errorMessage: {
      default: 'Please select a valid option.'
    },
    maxLength: {
      default: 2
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  computed: {
    filteredOptions () {
      if (!this.modelValue) return this.options
      const term = this.modelValue.toLowerCase()
      return this.options.filter(option => {
        const label = option.label.toLowerCase()
        const value = option.value.toLowerCase()
        return label.includes(term) || value.includes(term)
      })
    }
  },
  methods: {
    onInput (e) {
      const filtered = e.target.value.replace(/[^a-zA-Z]/g, '').toUpperCase()
      e.target.value = filtered
      this.$emit('update:modelValue', filtered)
      this.isOpen = filtered.length > 0
      this.$refs.input.setCustomValidity('')
    },
    onFocus () {
      if (this.modelValue && this.modelValue.length > 0) {
        this.isOpen = true
      }
    },
    validateSelection () {
      const value = this.modelValue ? this.modelValue.trim() : ''
      if (this.required && value === '') {
        this.$refs.input.setCustomValidity(this.errorMessage)
        return
      }
      if (value.length > 0 && value.length < this.maxLength) {
        this.$refs.input.setCustomValidity(this.errorMessage)
        return
      }
      const isValid = this.options.some(
        (option) => option.value.toLowerCase() === value.toLowerCase()
      )
      if (!isValid && value !== '') {
        this.$refs.input.setCustomValidity(this.errorMessage)
      } else {
        this.$refs.input.setCustomValidity('')
      }
    },
    selectOption (option) {
      this.$emit('update:modelValue', option.value)
      this.isOpen = false
      this.$refs.input.setCustomValidity('')
    },
    handleClickOutside (e) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(e.target)) {
        this.isOpen = false
        this.validateSelection()
      }
    },
    clearSelection () {
      this.$emit('update:modelValue', '')
      this.isOpen = false
      this.$refs.input.setCustomValidity('')
    }
  },
  mounted () {
    this._handleClickOutsideRef = this.handleClickOutside.bind(this)
    document.addEventListener('mousedown', this._handleClickOutsideRef)
  },
  beforeUnmount () {
    document.removeEventListener('mousedown', this._handleClickOutsideRef)
  }
}
</script>
